export const readableDisabledButtonSx = {
  '&.Mui-disabled': {
    opacity: 1,
    bgcolor: '#000000',
    color: 'rgba(230, 237, 243, 0.48)',
    boxShadow: 'none',
    borderColor: 'rgba(230, 237, 243, 0.28)',
    cursor: 'not-allowed',
    pointerEvents: 'none',
  },
};

export const primaryActionButtonSx = {
  borderRadius: 2,
  minHeight: 44,
  px: 2.5,
  textTransform: 'none',
  fontWeight: 700,
  bgcolor: '#000000',
  border: '1px solid #39ff14',
  color: '#39ff14',
  boxShadow: '0 0 0 1px rgba(57, 255, 20, 0.10), 0 0 18px rgba(57, 255, 20, 0.14)',
  '&:hover': {
    bgcolor: '#39ff14',
    color: '#000000',
    borderColor: '#39ff14',
    boxShadow: '0 0 0 1px rgba(57, 255, 20, 0.10), 0 0 18px rgba(57, 255, 20, 0.14)',
  },
  '&:active': {
    bgcolor: '#000000',
    color: '#39ff14',
    borderColor: '#39ff14',
  },
  '&.Mui-focusVisible': {
    outline: '2px solid #39ff14',
    outlineOffset: 2,
  },
  ...readableDisabledButtonSx,
};

export const secondaryActionButtonSx = {
  borderRadius: 2,
  minHeight: 44,
  px: 2.5,
  textTransform: 'none',
  bgcolor: 'transparent',
  border: '1px solid #39ff14',
  color: '#fff',
  '&:hover': {
    bgcolor: 'rgba(57,255,20,0.08)',
    color: '#39ff14',
    borderColor: '#39ff14',
    boxShadow: '0 0 0 1px rgba(57, 255, 20, 0.10), 0 0 18px rgba(57, 255, 20, 0.14)',
  },
  '&:active': {
    color: '#39ff14',
  },
  ...readableDisabledButtonSx,
};

export const outlineActionButtonSx = {
  borderRadius: 2,
  minHeight: 44,
  px: 2.5,
  textTransform: 'none',
  bgcolor: 'transparent',
  borderColor: '#39ff14',
  color: '#fff',
  '&:hover': {
    bgcolor: 'rgba(57,255,20,0.08)',
    color: '#39ff14',
    borderColor: '#39ff14',
    boxShadow: '0 0 0 1px rgba(57, 255, 20, 0.10), 0 0 18px rgba(57, 255, 20, 0.14)',
  },
  '&:active': {
    color: '#39ff14',
  },
  ...readableDisabledButtonSx,
};

export const selectedActionButtonSx = {
  borderRadius: 2,
  minHeight: 44,
  px: 2.5,
  textTransform: 'none',
  fontWeight: 700,
  bgcolor: '#000000',
  border: '1px solid #39ff14',
  color: '#39ff14',
  boxShadow: '0 0 0 1px rgba(57, 255, 20, 0.10), 0 0 18px rgba(57, 255, 20, 0.14)',
  '&:hover': {
    bgcolor: '#39ff14',
    color: '#000000',
    borderColor: '#39ff14',
    boxShadow: '0 0 0 1px rgba(57, 255, 20, 0.12), 0 0 22px rgba(57, 255, 20, 0.18)',
  },
  '&:active': {
    bgcolor: '#000000',
    color: '#39ff14',
    borderColor: '#39ff14',
  },
  '&.Mui-focusVisible': {
    outline: '2px solid #39ff14',
    outlineOffset: 2,
  },
  '&.Mui-disabled': {
    opacity: 1,
    bgcolor: '#000000',
    color: '#39ff14',
    borderColor: '#39ff14',
    boxShadow: '0 0 0 1px rgba(57, 255, 20, 0.10), 0 0 18px rgba(57, 255, 20, 0.14)',
    cursor: 'not-allowed',
  },
};
